var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.link)?_c('MainTab',{staticClass:"submenu-category-title",attrs:{"data-test-id":"bottom-navigation-route-lapro-help","href":_vm.link}},[_c('v-icon',{staticClass:"submenu-list-icon",attrs:{"color":"text"}},[_vm._v("$vuetify.icons.question")]),_vm._v(_vm._s(_vm.l.t('app.help', 'Help'))+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }